<div class="select-container">
    <i class="bi"
        [class]="(familyPrivateDataModel().invitationType | invitationTypeIcon: 'key') + ' ' + familyPrivateDataModel().invitationType">
        <label for="invitationTypeSelect">Type d'invitation:</label>
    </i>
    <select class="form-select" [class]="familyPrivateDataModel().invitationType" id="invitationTypeSelect"
        aria-label="Floating label select" [formField]="familyPrivateDataForm.invitationType">
        @for (option of invitationTypesOptions; track option.getKey()) {
        <option [selected]="familyPrivateDataModel().invitationType === option.getKey()" [value]="option.getKey()"
            [disabled]="familyPrivateDataModel().invitationType === option.getKey() || option.getKey() === ''">
            {{ option.getValue() }}
        </option>
        }
    </select>

</div>
<div class="select-container">
    <i class="bi"
        [class]="(rsvpDataModel().attendingStatus | attendingIcon: 'key') + ' ' + rsvpDataModel().attendingStatus">
        <label for="participationSelect">Participation:</label>
    </i>
    <select class="form-select" id="participationSelect" aria-label="Floating label select"
        [formField]="rsvpDataForm.attendingStatus">
        @for (option of attendingStatusOptions; track option.getKey()) {
        <option [selected]="rsvpDataModel().attendingStatus === option.getKey()" [value]="option.getKey()"
            [disabled]="rsvpDataModel().attendingStatus === option.getKey() || option.getKey() === 'NOT_RESPONDED'">
            {{ option.getValue() }}
        </option>
        }
    </select>
</div>

<div class="switch-container ib">
    <div class="form-check form-switch form-check-reverse">
        <label for="participationSelect">Conjoint:</label>
        <input class="form-check-input" type="checkbox" role="switch"
            [formField]="familyPrivateDataForm.canInviteCouple">
    </div>
    <div class="form-check form-switch form-check-reverse">
        <label for="participationSelect">Enfant(s):</label>
        <input class="form-check-input" type="checkbox" role="switch"
            [formField]="familyPrivateDataForm.canInviteChildren">
    </div>
    <div class="form-check form-switch form-check-reverse">
        <label for="participationSelect">Brunch:</label>
        <input class="form-check-input" type="checkbox" role="switch" [formField]="rsvpDataForm.staysForBrunch">
    </div>
</div>
<div class="form-floating dep-container ib">
    <input class="form-control" placeholder="34" id="floatingInputDepartement"
        [formField]="familyPrivateDataForm.departement">
    <label for="floatingInputDepartement">Dep.</label>
</div>

<div class="adults-container row mt-4">
    <div class="form-floating col-2 p-0 mb-4">
        <h5>Personne 1 :</h5>
    </div>
    <div class="form-floating col-4 p-0">
        <input class="form-control" placeholder="Commentaire" id="floatingInputPerson1Lastname"
            [formField]="rsvpDataForm.person1.lastName">
        <label for="floatingInputPerson1Lastname">Nom</label>
    </div>
    <div class="form-floating offset-1 col-4 p-0">
        <input class="form-control" placeholder="Reponse" id="floatingInputPerson1Firstname"
            [formField]="rsvpDataForm.person1.firstName">
        <label for="floatingInputPerson1Firstname">Prenom</label>
    </div>
    @if (!!rsvpDataModel().person2) {
    <div class="form-floating col-1 p-0">
        <button type="button" class="btn btn-outline-danger" (click)="removeAdult('person1')"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="form-floating col-2 p-0">
        <h5>Personne 2 :</h5>
    </div>
    <div class="form-floating col-4 p-0">
        <input class="form-control" placeholder="Commentaire" id="floatingInputPerson2Lastname"
            [formField]="rsvpDataForm.person2!.lastName">
        <label for="floatingInputPerson2Lastname">Nom</label>
    </div>
    <div class="form-floating offset-1 col-4 p-0">
        <input class="form-control" placeholder="Reponse" id="floatingInputPerson2Firstname"
            [formField]="rsvpDataForm.person2!.firstName">
        <label for="floatingInputPerson2Firstname">Prenom</label>
    </div>
    <div class="form-floating col-1 p-0">
        <button type="button" class="btn btn-outline-danger" (click)="removeAdult('person2')"><i class="bi bi-x-lg" ></i></button>
    </div>
    } @else if (familyPrivateDataModel().canInviteCouple) {
    <button type="button" class="btn btn-outline-secondary mt-4 mb-4 col-11" (click)="addAdult()">
        Ajouter un conjoint
    </button>
    }

</div>

<div class="childs-container row">
    @for (child of rsvpDataForm.childs; track $index) {
    <div class="form-floating col-2 p-0 mb-4">
        <h5>Enfant {{$index + 1}} :</h5>
    </div>
    <div class="form-floating col-4 p-0">
        <input class="form-control" [id]="'floatingTextareaChildNom'+$index" [formField]="child.lastName"
            placeholder="" />
        <label [for]="'floatingTextareaChildNom'+$index">Nom</label>
    </div>
    <div class="form-floating offset-1 col-4 p-0">
        <input class="form-control" [id]="'floatingTextareaChildPrenom'+$index" +$index [formField]="child.firstName"
            placeholder="" />
        <label [for]="'floatingTextareaChildPrenom'+$index" +$index>Prenom</label>
    </div>
    <div class="form-floating col-1 p-0">
        <button type="button" class="btn btn-outline-danger" (click)="removeChild($index)"><i class="bi bi-x-lg"></i></button>
    </div>
    }

    @if (familyPrivateDataModel().canInviteChildren) {
    <button type="button" class="btn btn-outline-secondary mt-4 mb-4 col-11" (click)="addChild()">
        Ajouter un enfant
    </button>
    }
</div>

<div class="textarea-container row">
    <div class="form-floating col-5 p-0">
        <textarea class="form-control" placeholder="Commentaire" id="floatingTextarea1"
            [formField]="rsvpDataForm.comment!"></textarea>
        <label for="floatingTextarea1">Commentaire</label>
    </div>
    <div class="form-floating offset-1 col-5 p-0">
        <textarea class="form-control" placeholder="Reponse" id="floatingTextarea2"
            [formField]="rsvpDataForm.bonusQuestionAnswer!"></textarea>
        <label for="floatingTextarea2">Reponse a la question bonus</label>
    </div>
</div>
<div class="actions">
    <button type="button" class="btn btn-primary right" (click)="validate()"
        [disabled]="buttonConfimDisabled()">Confirmer</button>
</div>